import { TOASTS } from './BulkCreateUserWizard/copy';

export const reportPathFor = (id) =>
  `/management/bulk_user_imports/${id}/download.csv`;

/**
 * What to say about a finished bulk import (Figma 787:77019).
 *
 * Plain data rather than a KeyDS payload, so the copy can be asserted without a
 * renderer; UsersContent turns it into a notification. Built from the event's
 * own payload rather than from a fetch, so a notice that arrives while the admin
 * is elsewhere in the tool still reads correctly.
 *
 * `null` for an event this page has no toast for, so an unknown status is
 * ignored rather than raising a blank notification.
 */
export default function bulkImportToast(event) {
  const { status, succeeded = 0, failed = 0 } = event.payload || {};

  // The report is the point of the toast for the two outcomes with failures in
  // them, and still useful for the third: it names the usernames the server
  // derived, which the admin has no other way to learn.
  const reportPath = event.subjectId ? reportPathFor(event.subjectId) : null;

  if (status === 'success') {
    return {
      intent: 'success',
      title: TOASTS.success.title,
      body: TOASTS.success.body(succeeded),
      reportPath,
    };
  }

  if (status === 'partial_success') {
    return {
      intent: 'warning',
      title: TOASTS.partial.title,
      body: TOASTS.partial.body(succeeded, failed),
      reportPath,
    };
  }

  if (status === 'failure') {
    return {
      // KeyDS Notification calls this one "danger"; the mockup draws it red.
      intent: 'danger',
      title: TOASTS.failure.title,
      body: TOASTS.failure.body,
      reportPath,
    };
  }

  return null;
}
